import {useQuery} from '@tanstack/react-query';
import {getPaymethodModeTypes} from '$api/frontdesk';

export const usePaymentMethodTypesHook = () => {
  return useQuery({
    queryKey: ['paymethod-mode-types'],
    queryFn: getPaymethodModeTypes,
  });
};
